export default "__VITE_ASSET__Dv3qfHOx__"